export default {
     "inc-speed-support":{
          "effectNames":["Aura_mystic"]
     },
     "inc-gold-drop":{
          "effectNames":[]
     },
     "damage_enemy":{
          "effectNames":[
              "Aura_glow", //by tap
              "Aura_magic" //by got hit
          ]
     },
     "poison-enemy":{
          "effectNames":[]
     },
     "inc_mana":{
          "effectNames":["Aura_water"]
     },
     "inc_mana_refill_speed":{
          "effectNames":["Aura_soap"]
     },
     "inc_critical_hit_ratio":{
          "effectNames":["Aura_shine"]
     },
     "inc_gold_enemy_drop":{
          "effectNames":[]
     },
     "inc_pet_active_time":{
          "effectNames":[]
     },
     "inc_powerup_capacity":{
          "effectNames":["Aura_trails"]
     },
     "inc_hp":{
          "effectNames":[]
     },
     "fill_hp":{
          "effectNames":["Aura_healing"]
     },
     "fill_mana":{
          "effectNames":["Aura_soap"]
     },
     "inc_dps":{
          "effectNames":["Aura_gold"]
     },
     "freeze-enemy":{
          "effectNames":[]
     },
     "sheep-enemy":{
          "effectNames":[]
     },
     "inc_size_hero":{
          "effectNames":[]
     },
     "revive_hero":{
          "effectNames":[]
     },
     "revive_support":{
          "effectNames":[]
     },
     "cure_freeze":{
          "effectNames":[]
     },
     "cure_poison":{
          "effectNames":[]
     },
     "cure_sheep":{
          "effectNames":[]
     },
     "cure_fire":{
          "effectNames":[]
     },
     "inc_bag_slot":{
          "effectNames":[]
     },
     "auto_tap":{
          "effectNames":[]
     },
     "holding_tap":{
          "effectNames":[]
     },
}